export default __webpack_public_path__ + "static/media/Mask Group 28@2x.003d2923.png";